import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from '../../config/environment';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class CanceladosService {

  constructor(private http: HttpClient, private Conf: Config) { }

  public getApplicantsReportByArea(data) {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getApplicantsReportByArea';
    let request = Object.assign({}, data);
    request.area = "CANCELADOS";

    return this.http.post(url, request, httpOptions);
  }

  public getApplicantDetail(data) {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getApplicantDataByArea';

    return this.http.post(url, data, httpOptions);
  }

  public saveApplicant(data) {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'saveApplicantDataByArea';
    let request = Object.assign({}, data);
    request.area = "CANCELADOS";

    return this.http.post(url, request, httpOptions);
  }

  public getValidationAccion() {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getValidationAccion';
    let request = { "area": "CANCELADOS" };

    return this.http.post(url, request, httpOptions);
  }

  public getValidationMotivo(data: any) {
    let httpOptions = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getValidationMotivo';
    let request = Object.assign({}, data);
    request.area = "CANCELADOS";

    return this.http.post(url, request, httpOptions);
  }
}
